import {
  GET_PROMOTION,
  GET_PROMOTIONS,
  SET_ALL_PROMOTIONS,
  UPDATE_PROMOTION,
  CREATE_PROMOTION,
} from "../../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
};

const promotiontReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_PROMOTIONS:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_PROMOTIONS:
      return {
        ...state,
        getList: action.payload,
      };
    case CREATE_PROMOTION:
      return {
        ...state,
        getData: action.payload,
      };
    case GET_PROMOTION:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_PROMOTION:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default promotiontReducer;
